import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@/store'
import { HeaderWrapper, HeaderLeft, HeaderRight } from './style'

export default memo(function PlayHeader() {
    const { currentSong, playList } = useSelector((state: RootState) => ({
        currentSong: state.player.currentSong,
        playList: state.player.playList,
    }))

    return (
        <HeaderWrapper>
            <HeaderLeft>
                <h3>播放列表({playList.length})</h3>
                <div className="operator">
                    <button>
                        <i className="sprite_playlist icon favor"></i>
                        收藏全部
                    </button>
                    <button>
                        <i className="sprite_playlist icon remove"></i>
                        清除
                    </button>
                </div>
            </HeaderLeft>
            <HeaderRight>{currentSong.name}</HeaderRight>
        </HeaderWrapper>
    )
})
